import React from 'react';
import TextField from 'material-ui/TextField';

export default props => {
  return (
    <TextField
      {...props.inputProps}
      {...props.input}
      errorText={props.meta.touched && props.meta.error && props.meta.error}
    />
  );
};



// WEBPACK FOOTER //
// src/modules/forms/components/TextField.js